export default (content, accent_color = null) => {
  let shoppable = '';
  let color = '';
  if (content.shoppable_image.is_shoppable && content.shoppable_image.shoppable_products.length > 0) {
    const shoppable_products = content.shoppable_image.shoppable_products.map((product) => {
      if (product.variant) {
        return `${product.handle}:${product.variant}`;
      }
      return `${product.handle}`;
    });
    shoppable = `data-shoppable-image="${shoppable_products}"`;
  }
  if (accent_color) {
    color = `data-accent-color="${accent_color}"`;
  }
  const html = `
    <div class="ShoppableImage" ${shoppable} ${color}>
      <img data-shoppable-source-image class="ShoppableImage__Image" width="458" height="196" src="${content.img_url}" loading="lazy" alt="${content.img_alt}" />
    </div>
  `;
  return html;
};
